// removed by extract-text-webpack-plugin
module.exports = {"title":"_20Zd3kDM3Q","other":"_3oMX0vHL5r"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/forms/secure/PayNowForm/PaymentInfoFields/AccountDetails/AccountDetails.module.less
// module id = 992
// module chunks = 3